<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5>
          <strong>Applied for Roles</strong>
        </h5>
        <div class="ts-app-shell--header_actions flexed">
          <button class="ts-btn ts-btn-small" @click="goBackToDashboard">Back to Dashboard</button>
        </div>
      </div>
      <el-alert
        :title="'This lists all applications sent to '+ $t('lorganization')+'s'"
        type="warning"
        :closable="false"
      ></el-alert>
      <el-table :data="tableData" v-if="!showNoData" :height="tableHeight">
        <el-table-column 
          :width="250"
          :label="$t('uorganization')" 
          prop="organisationName">
        </el-table-column>
        <el-table-column 
          :width="250"
          label="Position" 
          prop="roleTitle">
        </el-table-column>
        <el-table-column label="Matching Percentage" prop="matchedPercentage" :width="200">
            <template scope="scope">
              <div style="margin-left: 35px;">
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 0 && Math.floor(scope.row.matchedPercentage) <= 10" class="dot-quarter">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 11 && Math.floor(scope.row.matchedPercentage) <= 30" class="dot-half">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 31 && Math.floor(scope.row.matchedPercentage) <= 69" class="dot-third">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 70 && Math.floor(scope.row.matchedPercentage) <= 100" class="dot-whole">{{Math.floor(scope.row.matchedPercentage)}}%</span>
              </div>
            </template>            
          </el-table-column>
        <el-table-column label="Employer Status" prop="employerStatusName" :width="200"></el-table-column>
      </el-table>
    </div>
    <div v-if="showNoData" class="no-data">
      <div>
        <span class="fa-stack">
          <i class="fas fa-circle fa-stack-2x"></i>
          <i class="far fa-folder-open fa-stack-1x fa-inverse"></i>
        </span>
        <div class="no-data-text">{{ noDataText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableHeight: 500,
      tableData: [],
      showNoData: false,
      noDataText: ''
    };
  },
  created() {
    this.noDataText = 'No applications sent';
    this.$store
      .dispatch('jobseeker/getAppliedForRoles')
      .then(res => {
        this.tableData = res;
        this.showNoData = res.length == 0;

        this.calculateHeight();
      })
      .catch(res => {
        this.showNoData = true;
      });
  },
  methods: {
    calculateHeight() {
      var view = document.body.offsetWidth;
      var responsive = (view > 759) ? 0 : 100;
      var x = document.getElementsByClassName('padd-main');
      var y = document.getElementsByClassName('ts-app-shell--header');
      this.tableHeight = x[0].clientHeight - y[0].clientHeight - responsive;
    },
    goBackToDashboard(){
      this.$router.push({ name: 'JobSeekerApplicationsDashboard' });
    }
  }
};
</script>